import { useQuery } from '@apollo/client'
import { CoverImageDocument, CoverImageQuery } from '../../../graphql/generated'
import logger from '../../../utils/logger'

export default function useCoverImage(bucketId?: string, coverImageId?: string | null) {
  const { data, loading, error } = useQuery<CoverImageQuery>(CoverImageDocument, {
    skip: !bucketId || !coverImageId,
    variables: { bucketId: bucketId!, id: coverImageId! },
    fetchPolicy: 'cache-first',
    onError: (e) => {
      logger.error('Error fetching cover image:', e)
    }
  })

  return {
    data: data?.coverImage,
    loading,
    error
  }
}
